export default __webpack_public_path__ + "static/media/person_circle_filled.61fb0530.svg";